import React, { useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalContext } from '../../providers/GlobalProvider';
import { Grid } from '@mui/material';
import EARChatUI from 'components/Classify/EARChatUI';
import { peekExportClassifyHandoff } from 'utils/exportClassifyHandoff';

const ExportPage: React.FC = () => {
  const { cur_user, resetTicketDraft, wasTicketDraftRestored } =
    useContext(GlobalContext);
  // `seedProductDescription` / `seedFacts` arrive from the Design Assistant's "Send to Export
  // Workflow" handoff and are consumed by EARChatUI's seed effect, not here — they're declared
  // so the state shape stays honest about everything routed to this page.
  const location = useLocation<{
    resumeExportTicket?: unknown;
    seedProductDescription?: string;
    seedFacts?: Record<string, string | undefined>;
  }>();
  const [userHasMonitor, setUserHasMonitor] = useState(true);
  // Read at first render: EARChatUI's mount effect (a child effect, so it runs BEFORE this
  // page's effects) consumes the handoff record.
  const [classifyHandoffPending] = useState(() => Boolean(peekExportClassifyHandoff()));

  useEffect(() => {
    checkForMonitor();
  }, []);

  useEffect(() => {
    // ticketDraft is a single app-wide slot on GlobalContext shared by every
    // Case-based tool. Without this, arriving here after saving in a
    // different tool (e.g. Beneficial Ownership) inherits its leftover
    // draft/_id instead of starting fresh. Skip when explicitly resuming a
    // saved export ticket, or when a forced re-login redirect just restored
    // an in-progress draft (see GlobalProvider's ticketDraft /
    // sessionRecovery.ts).
    // A pending Classify-tool round trip (UX redesign slice B) restores the session in
    // EARChatUI — keep its ticket draft too.
    if (
      !location.state?.resumeExportTicket &&
      !wasTicketDraftRestored() &&
      !classifyHandoffPending
    ) {
      resetTicketDraft();
    }
  }, []);

  const requiredTiers = ['business', 'enterprise'];

  const checkForMonitor = () => {
    if (
      !requiredTiers.includes(cur_user.license) &&
      cur_user?.bite_super_admin !== true
    ) {
      setUserHasMonitor(false);
    }
  };

  return (
    <section className='standard-workflow-page Home-HeaderDown'>
      <div className='standard-workflow-page-content'>
        <Grid container className='standard-workflow-page-grid-host'>
          <Grid item xs={12} className='standard-workflow-page-grid-item'>
            <EARChatUI userHasMonitor={userHasMonitor} />
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default ExportPage;
